import type { FaireProductEntity } from "../../entity_types/product";

export const p_cabb42csgs: FaireProductEntity = {
  token: "p_cabb42csgs",
  type: "product",
  name: "Graza's Perfectly Salty Chips Fried in EVOO",
  brandToken: "b_2vdjeb6mau",
  brandName: "Graza",
  imageUrl:
    "https://cdn.faire.com/fastly/5c0b89869fdd0dc376fbb207ca1e2fe05eab69423cf4ba0b648c358366d0f236.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81df000c2a0ec1b0310241c17a60dd05cf986b0de8be79614f058eac3fd82212.png",
    "https://cdn.faire.com/fastly/41eb04378516ecad9cd287d98e454c78002832515cc1870ab1cc2ecec047cfd7.jpeg",
    "https://cdn.faire.com/fastly/b99413bcc6bcf2d5e1937db8ab6a532a791a35e8640210429719060d383cff2c.jpeg",
    "https://cdn.faire.com/fastly/d58ae10ae99606cd5b34ec46dcf05f57f713ae6ffa0df1c5f5312b76251a53ad.png",
    "https://cdn.faire.com/fastly/1f8c81f6a88fd1748c6c040c6ad82852024fb2f078c62bd60831f2376d70744d.png",
  ],
  priceDollars: 4.2,
  description:
    "Extra crispy and perfectly salty. Slow-fried in “Sizzle” extra virgin olive oil for maximum crunch and flavor.\n\nThese EVOO potato chips are made with super tasty Galician potatoes and flaky salt from the 6,000 year old Añana salt flats. Pretty cool, huh?!",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:18.607Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
